module.exports = __webpack_public_path__ + "5cbfb50edd6817022216e4ad5ccf4178.svg";